import React from 'react';
import Button from '../../components/buttons/Button';
import Btvoltar from '../../components/buttons/Btvoltar';
import TextInput from '../../components/form/TextInput';
import './styles-form-pagamento.css';
import Select from "../../components/form/Select";
import ButtonPlano from './ButtonPlano';

import AMEX from '../../img/AMEX.svg';
import BILLET from '../../img/BILLET.svg';
import DINERS from '../../img/DINERS.svg';
import ELO from '../../img/ELO.svg';
import HIPER from '../../img/HIPER.svg';
import HIPERCARD from '../../img/HIPERCARD.svg';
import MASTER_CARD from '../../img/MASTER_CARD.svg';
import VISA from '../../img/VISA.svg';
import AURA from '../../img/aura.svg';
import JCB from '../../img/jcb.svg';
import DISCOVER from '../../img/discover.svg';
import STRINGS from './../../data/language/language';
import TEMPO_MUSCULACAO from './../../data/TempoMusculacao';

const MENSAL = "M";

export default class PagamentoCartao extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      dono_dt_nasc: '',
      dono_cpf: '',
      nome_cartao: '',
      cartao: '',
      data_expiracao: '',
      cvc: '',
      tipo_pagamento: 'cartao',
      strings:STRINGS[window.LANGUAGE],
      parcelasOpt: [],
      parcelas: '',
      brand: '',
      periodicidade: props.dados.periodicidade
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.selectBandeira = this.selectBandeira.bind(this);
  }

  componentDidMount(){
    const n_parcelas = this.props.dados.max_parcelas;
    const valor = this.props.dados.valor.replace(',','.');
    const parcelas = [];

    for(let i = 0; i < n_parcelas; i++){
      const parc = (valor/(i+1)).toFixed(2);
      parcelas.push({
        label: `${i+1}x de R$${parc}`,
        value: (i+1)
      });
    }

    this.setState({ parcelasOpt: parcelas });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  selectBandeira(brand, e){
    e.preventDefault();
    this.setState({
      brand
    });
  }

  handleSelect (type, __args__){
    const obj = {};

    this.setState({
      parcelas: __args__
    });
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

    this.props.handleInputChange(event);
  }

  parcelasInterface() {
    const strings = this.state.strings;
    const parcelas = this.state.parcelas;

    if(this.state.periodicidade === MENSAL){
      return false;
    }

    return <div className="pure-u-1 pure-u-md-2-5">
        <Select
          key={Math.random()}
          name='parcelas'
          onChange={(e)=>this.handleSelect('parcelas',e)}
          title={`${strings.txtparcelas}`}
          options={this.state.parcelasOpt}
          value={parcelas}
        />
    </div>;
  }

  render(){
    const strings = this.state.strings;
    const boxPrcelas = this.parcelasInterface();

    return(
      <div className='wrapper-box-pay'>
        <div>
          <div className="box-input">
            <div className="box-input--title">{strings.txtCartao}</div>
              <div>
                <div className="box-bandeiras" id="box-bandeiras">
                  <span>
                    <a
                      className={this.state.brand==='Visa' ? 'ativo' : ''}
                      href='Visa'
                      onClick={(e) => this.selectBandeira('Visa',e)}>
                      <img src={VISA} />
                    </a>
                  </span>
                  <span>
                    <a
                      className={this.state.brand==='Master' ? 'ativo' : ''}
                      href='Master'
                      onClick={(e) => this.selectBandeira('Master',e)}>
                      <img src={MASTER_CARD} />
                    </a>
                  </span>
                  <span>
                    <a
                      className={this.state.brand==='Amex' ? 'ativo' : ''}
                      href='Amex'
                      onClick={(e) => this.selectBandeira('Amex',e)}>
                      <img src={AMEX} />
                    </a>
                  </span>
                  <span>
                    <a
                      className={this.state.brand==='Elo' ? 'ativo' : ''}
                      href='Elo'
                      onClick={(e) => this.selectBandeira('Elo',e)}>
                      <img src={ELO} />
                  </a>
                  </span>
                  <span>
                    <a
                      className={this.state.brand==='Aura' ? 'ativo' : ''}
                      href='Aura'
                      onClick={(e) => this.selectBandeira('Aura',e)}>
                      <img src={AURA} />
                  </a>
                  </span>
                  <span>
                    <a
                      className={this.state.brand==='JCB' ? 'ativo' : ''}
                      href='JCB'
                      onClick={(e) => this.selectBandeira('JCB',e)}>
                      <img src={JCB} />
                  </a>
                  </span>
                  <span>
                    <a
                      className={this.state.brand==='Diners' ? 'ativo' : ''}
                      href='Diners'
                      onClick={(e) => this.selectBandeira('Diners',e)}>
                      <img src={DINERS} />
                  </a>
                  </span>
                  <span>
                    <a
                      className={this.state.brand==='Discover' ? 'ativo' : ''}
                      href='Discover'
                      onClick={(e) => this.selectBandeira('Discover',e)}>
                      <img src={DISCOVER} />
                  </a>
                  </span>
                  <span>
                    <a
                      className={this.state.brand==='Hipercard' ? 'ativo' : ''}
                      href='Hipercard'
                      onClick={(e) => this.selectBandeira('Hipercard',e)}>
                      <img src={HIPERCARD} />
                  </a>
                  </span>
                  <input type='hidden' value={this.state.brand} name='brand' id="input-brand" />
                </div>
              </div>
            </div>
        </div>
        <div className='wrapper-pagamento'>

          <TextInput
            onChange={this.handleInputChange}
            name="nome_cartao"
            title={strings.txtNomeCartao}
            placeholder={strings.digiteNomeCartao}
            value={this.state.nome_cartao}
          >
          </TextInput>
          <TextInput
            value={this.state.cartao}
            onChange={this.handleInputChange}
            name="cartao"
            title={strings.txtNumeroCartao}
            placeholder={strings.digiteNCartao}
            value={this.state.cartao}
          >
          </TextInput>

          <div className="pure-g">

              <div className="pure-u-3-5">
                <TextInput
                  value={this.state.data_expiracao}
                  inputMask={{
                    name:'data_expiracao',
                    placeholder: strings.digiteData,
                    mask: "99/9999",
                    maskChar: "_"
                  }}
                  onChange={this.handleInputChange}
                  name="data_expiracao"
                  title={strings.txtDataExpiracao}
                  placeholder={strings.digiteData}
                  value={this.state.data_expiracao}
                >
                </TextInput>
              </div>
              <div className="pure-u-2-5">
                <TextInput
                  value={this.state.cpf_cnpj}
                  inputMask={{
                    name:'cvc',
                    placeholder: strings.digiteCVC,
                    mask: "9999",
                    maskChar: ""
                  }}
                  onChange={this.handleInputChange}
                  name="cvc"
                  title={strings.cvc}
                  placeholder={strings.digiteCVC}
                  value={this.state.cvc}
                >
                </TextInput>
              </div>
              {boxPrcelas}
          </div>
        </div>
        <div>
          <br />
          <div className='field-mandatory'>{strings.todoscamposObrigatorios}</div>
        </div>
        <br /><br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/pagamento/PagamentoCartao.js